<div class="hmhs-dynamic-form mat-typography mat-body mat-app-background">

  <!-- Form Page Heading -->
  @if (formConfig.pages[currentPage]?.showPageHeader) {
    <h1 class="form-heading">
      {{formConfig.pages[currentPage]?.pageHeader}}
    </h1>
  }

  <!-- Form Entries Loop -->
  @for (entry of formConfig.pages[currentPage]?.entries; track entry; let i = $index) {
    <div class="form-row"
      [ngClass]="{ 'hide-entry': entry.base?.foreverHidden }">
      <ptl-entry-as-json [entryConfig]="entry" [form]="pageFormGroups" [formConfig]="formConfig">
      </ptl-entry-as-json>
    </div>
  }

  <!-- Form Page Nav BUTTONS -->
  <div class="form-buttons">
    @if (!isLoading) {
      <button mat-raised-button color="primary" class="submit-button" (click)="submitButton()">
        SUBMIT
      </button>
    }
    @if (isLoading) {
      <mat-spinner [diameter]="25"></mat-spinner>
    }
  </div>
</div>
